module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/5@2x_4e169bdecdc9c4a83faba408cd1cce9b.png";